import styled from 'styled-components'

import { zIndex } from '@/styles'
import useCurrentSession from '@/hooks/use-current-session'
import useSessionComplete from '@/hooks/use-session-complete'

import BaseHeader from './base'
import DefaultHeader from './default-header'

const Menu = styled.nav`
  z-index: ${zIndex.dropdownMenu};
`

export type HeaderPosition = 'fixed' | 'sticky' | 'static'
export enum LogoStyle {
  WHITE = 'white',
  BLACK = 'black'
}

export enum HeaderNavStyle {
  WHITE = 'white',
  BLACK = 'black'
}

export enum HeaderTheme {
  TRANSPARENT = 'transparent',
  BORDERED = 'bordered',
  DEFAULT = 'default'
}

export interface HeaderProps {
  nav?: boolean
  children?: React.ReactNode
  theme?: HeaderTheme
  visible?: boolean
  showTranslate?: boolean
  position?: HeaderPosition
  banner?: React.ReactNode
  logoStyle?: LogoStyle
  headerNavStyle?: HeaderNavStyle
  showSearch?: boolean
  showNavItems?: boolean
  header?: React.ComponentType
  hideCity?: boolean
}

const Header: React.FC<HeaderProps> = ({
  children,
  theme,
  visible,
  nav = true,
  header: HeaderContent = DefaultHeader,
  banner = null,
  ...rest
}) => {
  const session = useCurrentSession()
  const hasSession = useSessionComplete()

  if (visible === false) return null

  return (
    <>
      <BaseHeader {...rest} theme={theme}>
        <HeaderContent
          hasSession={hasSession}
          session={session}
          nav={nav}
          {...rest}
        />
        {children}
        {banner}
      </BaseHeader>
      <Menu id="header-menu-popper"></Menu>
    </>
  )
}

export default Header
